import { booleanAttribute, EventEmitter, Injectable, Input, numberAttribute, Output } from '@angular/core';
import { Observable, Observer, BehaviorSubject, Subject, of } from 'rxjs';
import { share } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { StreamState } from '../interfaces/stream-state';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { style } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})

export class AudioService {
  // @Input({ transform: booleanAttribute })
  // disableRipple: boolean | undefined; 

  // @Input({ transform: booleanAttribute }) 
  // disabled: boolean | undefined; 
  
  // @Input({ transform: booleanAttribute }) 
  // discrete: boolean | undefined; 

  // @Input() displayWith: 
  // ((value: number) =>
  //     string | undefined) | undefined; 

  @Input({ transform: numberAttribute })
  value: number | any; 

  @Output()
  valueChange: EventEmitter<number> | undefined;

  // @Input({ transform: numberAttribute })
  // max: number | undefined; 

  // @Input({ transform: numberAttribute })
  // min: number | undefined; 

  // @Input({ transform: booleanAttribute })
  // showTickMarks: boolean | undefined; 

  // @Input({ transform: numberAttribute }) 
  // step: number | undefined; 

  
  url = '';
  OBPortalSvcURL = '';
  playerFile: string = '';  

  files: any = [
    {
      // url: "https://ia801609.us.archive.org/16/items/nusratcollection_20170414_0953/Man%20Atkiya%20Beparwah%20De%20Naal%20Nusrat%20Fateh%20Ali%20Khan.mp3", 
      // name: "cupcake"
    },
    // {
    //   url:
    //     "https://ia801504.us.archive.org/3/items/EdSheeranPerfectOfficialMusicVideoListenVid.com/Ed_Sheeran_-_Perfect_Official_Music_Video%5BListenVid.com%5D.mp3",
    //   name: "Perfect",
    //   artist: " Ed Sheeran"
    // },
    {
      // url:
      //   "https://ia801609.us.archive.org/16/items/nusratcollection_20170414_0953/Man%20Atkiya%20Beparwah%20De%20Naal%20Nusrat%20Fateh%20Ali%20Khan.mp3",
      // name: "Introduction",
      // artist: "Nusrat Fateh Ali Khan"
    },
    // {
    //   url:
    //     "https://audio.com/american-cruise-lines-1/audio/astoria-oregon",
    //   name: "Astoria, OR",
    //   artist: "13.0 LDB"
    // }
  ];

  muted: boolean | undefined;



  getFiles() {
    return of(this.files);
  }
  
  private stop$ = new Subject();
  private audioObj = new Audio(this.playerFile);
 
  private audioEvents = [
    'ended', 'error', 'play', 'MatSliderDragEvent', 'playing', 'pause', 'muted', 'muting', 'timeupdate', 'canplay', 'seeking', 'seeked', 'loadedmetadata', 'loadstart'
  ];
  private state: StreamState = {
    muting: false, 
    playing: false,
    readableCurrentTime: '',
    readableDuration: '',
    duration: undefined,
    currentTime: undefined,
    canplay: false,
    error: false,
    volume: undefined,
    muted: false, 
  };

  private streamObservable(playerFile: any) {
    return new Observable(observer => {
      this.audioObj.src = playerFile;
      this.audioObj.load();
      this.audioObj.play();

      const handler = (event: Event) => {
        this.updateStateEvents(event);
        observer.next(event);
      };
  
      this.addEvents(this.audioObj, this.audioEvents, handler);
      return () => {
        this.audioObj.pause();
        this.audioObj.currentTime = 0;
        this.removeEvents(this.audioObj, this.audioEvents, handler);
        this.resetState();
      };
    });
  }

  private addEvents(obj: any, events: any, handler: any) {
    events.forEach((event: any) => {
      obj.addEventListener(event, handler);
    });
  }

  private removeEvents(obj: any, events: any, handler: any) {
    events.forEach((event: any) => {
      obj.removeEventListener(event, handler);
    });
  }

  playStream(filename: any) {
    this.audioObj.currentTime=0;
    return this.streamObservable(filename).pipe(takeUntil(this.stop$));
  }

  play() {
    this.audioObj.play();
  }
  pause() {
    this.audioObj.pause();
  }
  forward() { 
    this.audioObj.currentTime += 10.0;
  }
  rewind() { 
    this.audioObj.currentTime -= 10.0;
  }
  skipintro() { 
    this.audioObj.currentTime = 10.0;
  }
  setMute(muted: boolean) {
    this.audioObj.muted = muted; 
  }
  getMute() {
    return this.audioObj.muted;
  }
  stop() {
    this.stop$.next('');
  }



  seekTo(time: number, format: string = 'm:ss') {
    // this.state.currentTime = this.audioObj.currentTime;
    return this.audioObj.currentTime < this.audioObj.duration;
  
    // return this.audioObj.currentTime < this.audioObj.duration;

    // changing time to 0 above makes it restart at 0 everytime you touch slider
    // changing time to 24 above makes it seek to 24 seconds everytime you touch slider 
  }






  formatTime(time: number, format: string = 'm:ss') {
    const momentTime = time * 1000;
    return moment.utc(momentTime).format(format);
  }
  formatLabel(time: number, format: string = 'm:ss') {
    const momentTime = time * 1000;
    if (time >= .5) {
      return moment.utc(momentTime).format(format);    }

    return `${momentTime}`;
  }



  private stateChange: BehaviorSubject<StreamState> = new BehaviorSubject(this.state);

  private updateStateEvents(event: Event): void {
    switch (event.type) {
      case 'canplay':
        this.state.duration = this.audioObj.duration;
        this.state.readableDuration = this.formatTime(this.state.duration);
        this.state.canplay = true;
        break;
      case 'playing':
        this.state.playing = true;
        break;
      case 'pause':
        this.state.playing = false;
        break;
      case 'timeupdate':
        this.state.currentTime = this.audioObj.currentTime;
        this.state.readableCurrentTime = this.formatTime(this.state.currentTime);
        break;
      case 'seekTo':
        this.state.currentTime = this.audioObj.currentTime;
        this.audioObj.currentTime < this.audioObj.duration;
        break;
      case 'error':
        this.resetState();
        this.state.error = true;
        break;
    }
    this.stateChange.next(this.state);
  }

  private resetState() {
    
    this.state = {
      muting: false,
      playing: false,
      readableCurrentTime: '',
      readableDuration: '',
      duration: undefined,
      currentTime: undefined,
      canplay: false,
      error: false, 
      volume: undefined,
      muted: false, 
    };
  }
  
  getState(): Observable<StreamState> {
    return this.stateChange.asObservable();
  }

 
  
}